export interface Rect {
  left: number;
  width: number;
}

export function positionChipPopover(chip: Rect, container: Rect, popWidth: number): { left: number; arrow: number } {
  const raw = chip.left - container.left;
  const maxLeft = container.width - popWidth - 12;
  const left = Math.min(Math.max(raw, 8), Math.max(8, maxLeft));
  const arrow = Math.max(18, raw - left + chip.width / 2);
  return { left, arrow };
}
